module.exports = __webpack_public_path__ + "static/media/bannerLeft.a09ca495.webp";